import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "@/components/site/Reveal";

const PHOTOS = [
    { src: "/brand/transform-2.webp", alt: "SHREDxpro founder transformation — before and after", label: "Founder" },
    { src: "/brand/transform-3.webp", alt: "SHREDxpro member transformation — before and after" },
    { src: "/brand/transform-4.webp", alt: "SHREDxpro member transformation — before and after" },
    { src: "/brand/transform-5.webp", alt: "SHREDxpro member transformation — before and after" },
    { src: "/brand/transform-6.webp", alt: "SHREDxpro member transformation — before and after" },
];

const Transformations = () => (
    <section id="transformations" data-testid="transformations-section" className="border-t border-white/5 bg-[#050a12] py-14 sm:py-20">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <FadeUp>
                <p className="eyebrow">Transformations</p>
                <h2 className="font-display mt-4 text-4xl leading-[1.08] text-white sm:text-5xl lg:text-6xl">
                    Real people. Real results.
                </h2>
                <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#9fb0c7]">
                    SHREDxpro members combine personalized training, dialed-in nutrition and daily
                    tracking. This is what consistency looks like.
                </p>
            </FadeUp>

            <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {PHOTOS.map((p, i) => (
                    <FadeUp key={p.src} delay={i * 0.1}>
                        <div
                            data-testid={`transformation-card-${i + 1}`}
                            className="group rounded-3xl bg-gradient-to-b from-[#45d1f5]/50 via-white/10 to-[#f0356f]/45 p-[1.5px] transition-shadow duration-300 hover:shadow-[0_0_50px_rgba(63,203,243,0.15)]"
                        >
                            <div className="relative overflow-hidden rounded-[calc(1.5rem-1.5px)] bg-[#0b1422]">
                                <img
                                    src={p.src}
                                    alt={p.alt}
                                    loading="lazy"
                                    className="aspect-square w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                                />
                                <div className="pointer-events-none absolute inset-y-0 left-1/2 w-px bg-white/25" />
                                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/55 to-transparent" />
                                <span className="absolute left-3 top-3 rounded-full border border-white/20 bg-black/55 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.2em] text-white/80 backdrop-blur-sm">
                                    Before
                                </span>
                                <span className="absolute right-3 top-3 rounded-full border border-[#3fcbf3]/40 bg-[#070c15]/70 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.2em] text-[#3fcbf3] backdrop-blur-sm">
                                    After
                                </span>
                                <span className="absolute bottom-3 left-3 text-[10px] font-bold uppercase tracking-[0.2em] text-white/70">
                                    {p.label === "Founder" ? "SHREDxpro founder" : "SHREDxpro member"}
                                </span>
                            </div>
                        </div>
                    </FadeUp>
                ))}
            </div>

            <FadeUp delay={0.15}>
                <div className="mt-12 text-center">
                    <p className="text-xs text-[#5c6b82]">
                        Individual results vary — built with personalized plans, smart tracking and
                        consistency.
                    </p>
                    <Link to="/register" data-testid="transformations-cta" className="btn-primary mt-6">
                        Start Your Transformation <ArrowRight className="h-4 w-4" />
                    </Link>
                </div>
            </FadeUp>
        </div>
    </section>
);

export default Transformations;
